<div class="mt-2 mb-2" *ngIf="(collection$ | async)">
  <span class="text-muted">{{'collection.listelement.badge' | translate}}:
    <a [routerLink]="['/collections', (collection$ | async)?.id]">
      {{ dsoNameService.getName(collection$ | async) }}
    </a>
    </span>
</div>
